// import React from 'react';
// import { useAuth } from '../AuthContext';
// import profileImage from '../images/user.png'; // Default profile image

// const ProfilePage = () => {
//   const { user } = useAuth();

//   return (
//     <div className="flex flex-col items-center p-8 bg-white-100 min-h-screen mt-15">
//       <div className="bg-white shadow-lg rounded-2xl w-full h-full max-w-3xl p-10">
//         {/* Profile Image */}
//         <div className="flex justify-center mb-6">
//           <img
//             src={profileImage}
//             alt="User Profile"
//             className="w-32 h-32 rounded-full border-4 border-blue-500 shadow-md"
//           />
//         </div>

        // {/* User Information */}
        // <div className="text-center">
        //   <h1 className="text-2xl font-semibold text-gray-800 mb-2">{user.username}</h1>
        //   <p className="text-gray-600 text-sm mb-4">Professional Profile</p>

        //   <div className="bg-gray-50 p-4 rounded-lg border border-gray-200">
        //     <div className="flex justify-between py-2 border-b">
        //       <span className="font-medium text-gray-700">User ID:</span>
        //       <span className="text-gray-600">{user.userID}</span>
        //     </div>
        //     <div className="flex justify-between py-2 border-b">
        //       <span className="font-medium text-gray-700">Company ID:</span>
        //       <span className="text-gray-600">{user.companyID}</span>
        //     </div>
        //     <div className="flex justify-between py-2">
        //       <span className="font-medium text-gray-700">Email:</span>
        //       <span className="text-gray-600">{user.username}@example.com</span>
        //     </div>
        //   </div>

//           {/* Actions */}
//           <div className="mt-6">
//             <button className="w-full bg-blue-500 text-white py-2 px-4 rounded-lg shadow hover:bg-blue-600 transition duration-200">
//               Edit Profile
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ProfilePage;


// import React from 'react';

// import profileImage from '../images/user.png'; // Default profile image

// const ProfilePage = () => {
 

  

//   return (
//     <div className="min-h-screen bg-gradient-to-b from-blue-900 to-blue-700 text-white">
//       {/* Navigation Bar */}
//       <nav className="from-blue-900 to-blue-700 p-4 flex  items-center ">
//         <div className="text-xl font-bold"></div>
       
//       </nav>

//       {/* Profile Section */}
//       <div className="max-w-5xl mx-auto bg-white shadow-lg rounded-lg overflow-hidden mt-8">
//         <div className="relative">
//           <div
//             src="/path-to-banner.jpg"
//             alt="Profile Banner"
//             className="w-full h-40 object-cover"
//           />
//           <div className="absolute -bottom-12 left-1/2 transform -translate-x-1/2">
//             <img
//               src={profileImage}
//               alt="User Profile"
//               className="w-24 h-24 rounded-full border-4 border-white shadow-lg"
//             />
//           </div>
//         </div>

//         <div className="text-center mt-16 p-6">
//           <h1 className="text-2xl font-bold text-gray-800">{user.username}</h1>
//           <p className="text-gray-600 text-sm mb-4">Professional Profile</p>

//         </div>

//         {/* Personal Information */}
//         <div className="p-6 bg-gray-100">
//           <h2 className="text-lg font-semibold text-gray-700 mb-4">Personal Information</h2>
          
//           <div className="bg-white shadow-md rounded-lg overflow-hidden">
            
//             {/* <table className="w-full text-left">
//               <tbody>
//                 <tr className="border-b">
//                   <td className="p-3 font-medium">Name:</td>
//                   <td className="p-3">{user.username}</td>
//                 </tr>
//                 <tr className="border-b">
//                   <td className="p-3 font-medium">Date of Birth:</td>
//                   <td className="p-3">{user.dob}</td>
//                 </tr>
//                 <tr className="border-b">
//                   <td className="p-3 font-medium">Email:</td>
//                   <td className="p-3">{user.email}</td>
//                 </tr>
//                 <tr className="border-b">
//                   <td className="p-3 font-medium">Contact No:</td>
//                   <td className="p-3">{user.contact}</td>
//                 </tr>
//                 <tr className="border-b">
//                   <td className="p-3 font-medium">Address:</td>
//                   <td className="p-3">{user.address}</td>
//                 </tr>
//                 <tr>
//                   <td className="p-3 font-medium">Description:</td>
//                   <td className="p-3">{user.description}</td>
//                 </tr>
//               </tbody>
//             </table> */}

// <div className="bg-gray-50 p-4 rounded-lg border border-gray-200">
//             <div className="flex justify-between py-2 border-b">
//               <span className="font-medium text-gray-700">User Name:</span>
//               <span className="text-gray-600">{user.username}</span>
//             </div>
//             <div className="flex justify-between py-2 border-b">
//               <span className="font-medium text-gray-700">Email:</span>
//               <span className="text-gray-600">{user.email}</span>
//             </div>
//             <div className="flex justify-between py-2">
//               <span className="font-medium text-gray-700">Company Name:</span>
//               <span className="text-gray-600">{user.companyName}</span>
//             </div>
//             <div className="flex justify-between py-2">
//               <span className="font-medium text-gray-700">Company Address:</span>
//               <span className="text-gray-600">{user.companyAddress}</span>
//             </div>
//             <div className="flex justify-between py-2">
//               <span className="font-medium text-gray-700">Company No:</span>
//               <span className="text-gray-600">{user.companyContactNo}</span>
//             </div>
            
//           </div>

//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ProfilePage;


// import React, { useState, useEffect } from "react";
// import { useAuth } from "../AuthContext"; 
// import profileImage from "../images/user.png"; 

// const ProfilePage = () => {
//   const { user } = useAuth(); 
//   const [userData, setUserData] = useState(null);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     console.log("AuthContext user object:", user);

//     if (!user || !user.userID || isNaN(user.userID)) {
//       console.error("Invalid user ID:", user?.userID);
//       setError("Invalid user ID. Cannot fetch user details.");
//       return;
//     }

//     const fetchUserData = async () => {
//       try {
//         const response = await fetch(`https://invoice.dockyardsoftware.com/api`);
//         if (!response.ok) {
//           throw new Error("Failed to fetch user details");
//         }
//         const data = await response.json();
//         console.log("User Data:", data);
//         setUserData(data);
//       } catch (error) {
//         console.error("Error fetching user details:", error);
//         setError(error.message);
//       }
//     };

//     fetchUserData();
//   }, [user]);

//   if (error) {
//     return <p className="text-red-500 mt-4">{error}</p>;
//   }

//   if (!userData) {
//     return <p className="text-gray-500 mt-4">Loading...</p>;
//   }

//   return (
//     <div className="min-h-screen bg-gradient-to-b from-blue-900 to-blue-700 text-white">
//       <nav className="from-blue-900 to-blue-700 p-4 flex items-center ">
//         <div className="text-xl font-bold"></div>
//       </nav>

//       <div className="max-w-5xl mx-auto bg-white shadow-lg rounded-lg overflow-hidden mt-8">
//         <div className="relative">
//           <div className="w-full h-40 object-cover bg-gray-300"></div>
//           <div className="absolute -bottom-12 left-1/2 transform -translate-x-1/2">
//             <img
//               src={profileImage}
//               alt="User Profile"
//               className="w-24 h-24 rounded-full border-4 border-white shadow-lg"
//             />
//           </div>
//         </div>

//         <div className="text-center mt-16 p-6">
//           <h1 className="text-2xl font-bold text-gray-800">{userData.userName}</h1>
//           <p className="text-gray-600 text-sm mb-4">Professional Profile</p>
//         </div>

//         <div className="p-6 bg-gray-100">
//           <h2 className="text-lg font-semibold text-gray-700 mb-4">Personal Information</h2>

//           <div className="bg-white shadow-md rounded-lg overflow-hidden">
//             <div className="bg-gray-50 p-4 rounded-lg border border-gray-200">
//               <div className="flex justify-between py-2 border-b">
//                 <span className="font-medium text-gray-700">User Name:</span>
//                 <span className="text-gray-600">{userData.userName}</span>
//               </div>
//               <div className="flex justify-between py-2 border-b">
//                 <span className="font-medium text-gray-700">Email:</span>
//                 <span className="text-gray-600">{userData.userEmail}</span>
//               </div>
//               <div className="flex justify-between py-2">
//                 <span className="font-medium text-gray-700">Company Name:</span>
//                 <span className="text-gray-600">{userData.companyName}</span>
//               </div>
//               <div className="flex justify-between py-2">
//                 <span className="font-medium text-gray-700">Company Address:</span>
//                 <span className="text-gray-600">{userData.companyAddress}</span>
//               </div>
//               <div className="flex justify-between py-2">
//                 <span className="font-medium text-gray-700">Company No:</span>
//                 <span className="text-gray-600">{userData.companyContactNumber}</span>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ProfilePage;

import React, { useState, useEffect } from "react";
import { useAuth } from "../AuthContext"; 
import profileImage from "../images/user.png"; 

const ProfilePage = () => {
  const { user } = useAuth(); 
  const [userData, setUserData] = useState(null);
  const [companyData, setCompanyData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!user || !user.userID || isNaN(user.userID)) {
      console.error("Invalid user ID:", user?.userID);
      setError("Invalid user ID. Cannot fetch user details.");
      return;
    }

    const fetchUserData = async () => {
      try {
        // Fetch user details from UserController
        const userResponse = await fetch(`https://invoice.dockyardsoftware.com/api/user/${user.userID}`);
        if (!userResponse.ok) {
          throw new Error("Failed to fetch user details");
        }
        const userData = await userResponse.json();
        console.log("User Data:", userData);
        setUserData(userData);

        // Fetch company details from CompanyController
        const companyResponse = await fetch(`https://invoice.dockyardsoftware.com/api/company/${userData.companyID}`);
        if (!companyResponse.ok) {
          throw new Error("Failed to fetch company details");
        }
        const companyData = await companyResponse.json();
        console.log("Company Data:", companyData);
        setCompanyData(companyData);

      } catch (error) {
        console.error("Error fetching details:", error);
        setError(error.message);
      }
    };

    fetchUserData();
  }, [user]);

  if (error) {
    return <p className="text-red-500 mt-4">{error}</p>;
  }

  if (!userData || !companyData) {
    return <p className="text-gray-500 mt-4">Loading...</p>;
  }

  return (
    <div className="min-h-screen bg-gradient-to-b from-blue-900 to-blue-700 text-white">
      <nav className="from-blue-900 to-blue-700 p-4 flex items-center ">
        <div className="text-xl font-bold">Profile</div>
      </nav>

      <div className="max-w-5xl mx-auto bg-white shadow-lg rounded-lg overflow-hidden mt-8">
        <div className="relative">
          <div className="w-full h-40 object-cover bg-gray-300"></div>
          <div className="absolute -bottom-12 left-1/2 transform -translate-x-1/2">
            <img
              src={profileImage}
              alt="User Profile"
              className="w-24 h-24 rounded-full border-4 border-white shadow-lg"
            />
          </div>
        </div>

        <div className="text-center mt-16 p-6">
          <h1 className="text-2xl font-bold text-gray-800">{userData.userName}</h1>
          <p className="text-gray-600 text-sm mb-4">Professional Profile</p>
        </div>

        <div className="p-6 bg-gray-100">
          <h2 className="text-lg font-semibold text-gray-700 mb-4">Personal Information</h2>

          <div className="bg-white shadow-md rounded-lg overflow-hidden">
            <div className="bg-gray-50 p-4 rounded-lg border border-gray-200">
              <div className="flex justify-between py-2 border-b">
                <span className="font-medium text-gray-700">User Name:</span>
                <span className="text-gray-600">{userData.userName}</span>
              </div>
              <div className="flex justify-between py-2 border-b">
                <span className="font-medium text-gray-700">Email:</span>
                <span className="text-gray-600">{userData.userEmail}</span>
              </div>
              <div className="flex justify-between py-2">
                <span className="font-medium text-gray-700">Company Name:</span>
                <span className="text-gray-600">{companyData.companyName}</span>
              </div>
              <div className="flex justify-between py-2">
                <span className="font-medium text-gray-700">Company Address:</span>
                <span className="text-gray-600">{companyData.companyAddress}</span>
              </div>
              <div className="flex justify-between py-2">
                <span className="font-medium text-gray-700">Company No:</span>
                <span className="text-gray-600">{companyData.companyContactNumber}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfilePage;
